// "added by AI" on anything the TearDrop Assistant added. Hover for when and
// what was asked; undo is on the AI activity page.
import { aiTitle, isAiRecord } from '../lib/aiActivity';

export default function AiTag({ record, style }) {
  if (!isAiRecord(record)) return null;
  return (
    <span className="ui-pill ui-pill--blue ai-tag" title={aiTitle(record)} style={style}>
      added by AI
    </span>
  );
}
